import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { IPromotion, PromotionStatus } from '@/models/promotion.model';
import { renderDate, renderDateRange, renderPrice } from '@/utils';
import { CouponActivitySwitch } from '../components';
import { DateFormats } from '@/constants/dates';

export const getCouponsColumns = (t: TFunction): TableColumnsType<IPromotion> => [
  {
    title: t('label_coupon_number'),
    dataIndex: 'code',
    key: 'code',
    render: (code: string) => <strong>{code}</strong>,
  },
  {
    title: t('label_discount_percentage'),
    dataIndex: 'rate',
    key: 'rate',
    render: (rate: number) => (rate ? `${rate}%` : '-'),
  },
  {
    title: t('label_apply_from_amount'),
    dataIndex: 'minOrderAmount',
    key: 'minOrderAmount',
    render: (minOrderAmount: number) => (minOrderAmount ? renderPrice(minOrderAmount) : '-'),
  },
  {
    title: t('label_period'),
    dataIndex: 'dateFrom',
    key: 'dateFrom',
    render: (_: string, record) => renderDateRange(record?.dateFrom ?? '', record?.dateTo ?? ''),
  },
  {
    title: t('label_updated_at'),
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (updatedAt: string) => renderDate(updatedAt, DateFormats.DATE_WITH_TIME),
  },
  {
    title: t('label_status'),
    dataIndex: 'status',
    key: 'status',
    width: 160,
    render: (status: PromotionStatus, record) => (
      <CouponActivitySwitch couponId={record.id} isActive={status === PromotionStatus.ACTIVE} />
    ),
  },
];
